import React from 'react';

function useDateRangePicker() {
  const [show, setShow] = React.useState<boolean>(false);

  return {
    show,
    setShow,
  };
}

export default useDateRangePicker;
